import apiCall from 'apps/investment/apiCalls/userProgramOrder';
import { CreatePage, DetailPage, EditPage } from 'common/ui/AdminCRUD/page';

import { columnsGenerator } from 'apps/investment/components/UserProgramOrders/config';
import { ListPage } from 'common/ui/admin-CRUD/page';
import ItemForm from './Form';
import ItemDetail from './detail';
import { FilterForm } from './filter-form';

export const InvestmentUserProgramOrderListPage = () => (
  <ListPage
    title="All Orders"
    apiCall={apiCall}
    columnsGenerator={columnsGenerator}
    FilterForm={FilterForm}
  />
);

export const InvestmentUserProgramOrderEditPage = props => (
  <EditPage
    title="Edit Order"
    apiCall={apiCall}
    listUrl={`/investment/orders`}
    ItemForm={ItemForm}
    resourceName="data"
    {...props}
  />
);

export const InvestmentUserProgramOrderDetailPage = props => (
  <DetailPage
    title="Order"
    apiCall={apiCall}
    listUrl={`/investment/orders`}
    ItemDetail={ItemDetail}
    resourceName="data"
    options={{ deleteEnabled: false, editEnabled: false }}
    {...props}
  />
);

export const InvestmentUserProgramOrderCreatePage = props => (
  <CreatePage
    title="Create Order"
    apiCall={apiCall}
    listUrl={`/investment/orders`}
    ItemForm={ItemForm}
    resourceName="data"
    {...props}
  />
);
